import styled, { css } from "styled-components";
import {
  getCssForExpandedView,
  getCssForExtraLargeView,
  getCssForLargeView,
  getCssForMobileView,
  getCssForTabletView
} from "styles/responsive";

type MainImage = {
  backgroundImageSet: {
    mobile: string;
    medium: string;
    expanded: string;
    large: string;
  };
};

export const MainImageContainer = styled.section<MainImage>`
  width: 100%;
  height: 85vh;
  display: flex;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;

  ${props =>
    getCssForMobileView(css`
      background-image: url(${props.backgroundImageSet.mobile});
    `)}

  ${props =>
    getCssForTabletView(css`
      background-image: url(${props.backgroundImageSet.medium});
    `)}

  ${props =>
    getCssForExpandedView(css`
      background-image: url(${props.backgroundImageSet.expanded});
    `)}

  ${props =>
    getCssForLargeView(css`
      background-image: url(${props.backgroundImageSet.large});
      bakcground-position-x: 64%;
    `)}

    ${props =>
      getCssForExtraLargeView(css`
        position: relative;
        background-image: url(${props.backgroundImageSet.large});
        background-position-y: 64%;
        background-size: cover;

        :before {
          content: "";
          background-image: linear-gradient(
            90deg,
            rgba(228, 231, 222, 1) 20%,
            rgba(228, 231, 222, 0) 100%
          );
          position: absolute;
          width: 20%;
          height: 100%;
          left: 0;
          top: 0;
        }
      `)}
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.grey["800"]};
`;

export const MainContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 3rem;
  margin-top: 2.5rem;
  gap: 32px;

  ${getCssForMobileView(css`
    margin-left: 32px;
    width: 100%;
  `)}

  ${getCssForLargeView(css`
    margin-left: 48px;
  `)}

  ${getCssForExtraLargeView(css`
    z-index: 1;
  `)}
`;

export const Title = styled.h1`
  margin: 0;
  font-family: ${({ theme }) => theme.primaryFontFamily};
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: 0.02px;
`;

export const CardList = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  width: 313px;
`;

export const LandingInfoMessage = styled.p`
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const LandingInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
